// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const YatesWrapper: StatelessFunctionalComponent<*> = styled.div`
  padding: 20px 10px !important;
  
  .Yates {
    &-formRow {
      margin-top: 16px;
      display: flex;
      justify-content: center;

      &-1 {
        max-width: 450px;
        text-align: center;
        margin: auto !important;
      }

      &-2 {
        max-width: 300px;
        text-align: center !important;
        margin: auto !important;
      }
    }

    @media (max-width: 700px){
      &-formRow {
        flex-direction: column;
      }
    }

    &-formRow > * {
      margin: 0 10px;
    }

    &-placeHolder {
      max-width: 500px;
      font-size: 15px;
      padding-top: 10px;
      margin: 0 auto;
      color: var(--text-color-1);
    }

    &-image {
      cursor: pointer;
      padding: 0px 10px;

      &-content {
        display: grid;
        gap: 15px;
      }

      &-container {
        position: relative;
      }

      &-text {
        font-size: 1.5em;
        color: var(--text-color-2);

        &-error {
          padding-top: '15px';
          font-size: 1.5em;
          text-align: center;
          justify-content: center; 
          color: var(--input-error-color);
        }
      }

      &-button {
        margin: auto;
        border-radius: 5px;
        background-color: var(--blue-color);
        padding: 12px 15px;
        
        &-error {
          background-color: var(--input-error-color);
        }
        
        &-container {
          display: contents;
          height: 70px;
        }
      }

      &-preview {
        margin: auto;
        border-radius: 5px;
        height: 70px;
      }

      &-cross {
        position: absolute;
        top: 0;
      }
    }

    &-textarea {
      color: var(--text-color-1);

      &-input {
        width: 97.5%;
        font-size: 14px;
        padding: 12px 0;
        font-family: inherit;
        margin-top: 10px;
        margin-bottom: 6px;
        padding: 10px;
        resize: vertical;
        border-radius: 10px;
      }
    }

    &-imageContainer {
      display: grid;
      text-align: center;
      grid-template: 1fr / 1fr 1fr 1fr;
      padding-top: 15px;
      grid-gap: 20px 0px;
    }

    @media (max-width: 650px){
      &-imageContainer {
        display: grid;
        text-align: center;
        grid-template: 1fr / 1fr;
        padding-top: 25px;
        grid-gap: 30px 0px;
        max-width: 500px;
        margin: auto;
      }
    }
  }

  .Price {
    &-content {
      color: gray;
    }

    &-content_1 {
      padding-top: 24px;
      font-weight: 500;
      font-size: 2.2em;
    }

    &-content_2 {
      padding: 16px 32px;
      font-size: 1.6em;
    }

    &-content_3 {
      padding: 0px 64px 20px 64px;
      font-size: 1.6em;
    }

    &-content_disabled {
      opacity: 0.5;
    }
  }
`;

export default YatesWrapper;
